import { setTier, setTrialStartedAt } from './license';
import { isDesktop } from './platform';

const API = import.meta.env.VITE_API_URL || 'https://api.scrivar.com';

/**
 * Fetch the server-authoritative trial status (with this device's fingerprint,
 * on desktop) and apply it to the client tier + cached start. No-ops gracefully
 * offline. Call this AFTER /account has resolved (it already set the paid tier).
 * @param {string} idToken Firebase ID token
 */
export async function refreshTrialStatus(idToken) {
  if (!idToken) return;
  // Trial is desktop-only — web stays on its free/paid model. Skip on web.
  if (!isDesktop()) return;
  let fingerprintHash = null;
  try {
    if (window.electronAPI?.getDeviceFingerprint) {
      fingerprintHash = await window.electronAPI.getDeviceFingerprint();
    }
  } catch { fingerprintHash = null; }

  try {
    const res = await fetch(`${API}/trial/status`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${idToken}` },
      body: JSON.stringify({ fingerprintHash }),
    });
    if (!res.ok) return;
    const data = await res.json();
    if (data?.tier) setTier(data.tier);
    setTrialStartedAt(data?.trial?.trialStartedAt ?? null);
  } catch {
    /* offline — keep cached trial start; getTrialDaysRemaining uses it */
  }
}
